import store from '../store/store'
import axios from '../axios'

export default class ActivityService {

  getNewCurrentUserAlerts() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getNewCurrentUserAlerts'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getActiveCurrentUserAlerts() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getActiveCurrentUserAlerts'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllCurrentUserAlerts() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getAllCurrentUserAlerts'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAlert(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/getAlert/' + id
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateAlert(id, body) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/updateAlert/' + id
        var response = await axios.put(path, body)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

}